import Modal from "react-bootstrap/Modal";
import { useSecretaryStore } from "../../../hooks";
import { translations } from "../../../helpers";

export const ModalViewDoctor = ({ viewDoctor, setViewDoctor, doctor }) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <Modal
      show={viewDoctor}
      onHide={() => setViewDoctor(false)}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title" id="exampleModalLabel1">
          Perfil del doctor
        </h5>
      </Modal.Header>
      <Modal.Body>
        {doctor && (
          <ul className="list-unstyled mb-0 mt-0">
            {/* Datos principales */}
            <>
              <li className="d-flex ms-0">
                <h6>Documento:</h6>
                <p className="text-muted ms-2">{doctor.document}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Tipo de documento:</h6>
                <p className="text-muted ms-2">
                  {doctor.documentTypeDescription}
                </p>
              </li>
              <li className="d-flex ms-0">
                <h6>Nombres:</h6>
                <p className="text-muted ms-2">{doctor.firstName}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Apellidos:</h6>
                <p className="text-muted ms-2">{doctor.lastName}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Email:</h6>
                <p className="text-muted ms-2">{doctor.email}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>No. celular:</h6>
                <p className="text-muted ms-2">{doctor.phoneNumber}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Pais celular:</h6>
                <p className="text-muted ms-2">{doctor.countryPhoneName}</p>
              </li>
              <hr />
              <li className="d-flex ms-0">
                <h6>Dirección</h6>
              </li>
              <li className="d-flex ms-0">
                <h6>Pais:</h6>
                <p className="text-muted ms-2">{doctor.country}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Departamento:</h6>
                <p className="text-muted ms-2">{doctor.department}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Ciudad:</h6>
                <p className="text-muted ms-2">{doctor.city}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Dirección:</h6>
                <p className="text-muted ms-2">{doctor.address}</p>
              </li>
              <hr />
              <li className="d-flex ms-0">
                <h6>Género:</h6>
                <p className="text-muted ms-2">{doctor.genderName}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Registro médico:</h6>
                <p className="text-muted ms-2">{doctor.medicalRegistry}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Especialidad:</h6>
                <p className="text-muted ms-2">{doctor.specialtyName}</p>
              </li>
              <li className="d-flex ms-0">
                <h6>Estado:</h6>
                <p className="text-muted ms-2">
                  {translations[doctor.stateName] || doctor.stateName}
                </p>
              </li>
            </>

            {/* Sedes */}
            <>
              <li className="d-flex ms-0">
                <h6>Sedes - ips:</h6>
              </li>
              {doctor.headquarters.map((headquarter, index) => (
                <li className="d-flex ms-0" key={headquarter.id}>
                  <h6>{index + 1}:</h6>
                  <p className="text-muted ms-2">
                    Sede: {headquarter.name}, Ips: {headquarter.ipsName}
                  </p>
                </li>
              ))}
            </>
          </ul>
        )}
      </Modal.Body>
    </Modal>
  );
};
